export default "__VITE_ASSET__Bb4IxS9h__"